var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, IconButton, Table, TableBody, TableContainer, TableRow, TableCell, } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ResultTableRows from "./ResultTableRows";
import TrialTableHeaderRow from "./TrialTableHeaderRow";
import "./result-table.css";
const ResultTableContainer = ({ distinctColumns, handleColumnClick, headerRowSortConfig, resultRowSortConfig, trialResults, trialId, categoryId, checkedDataTypeIds, // for the ResultTableRows
 }) => {
    const tableContainerRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState(null);
    const scrollLeft = () => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
        }
    };
    const scrollRight = () => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
        }
    };
    const onColumnClick = (columnIndex, columnId) => {
        var _a;
        //scroll all the way to the left
        (_a = tableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ left: 0, behavior: "smooth" });
        // setLoading(true);
        handleColumnClick(columnIndex, columnId);
    };
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            try {
                const result = trialResults.map((item) => (Object.assign({}, item)));
                const rows = result.filter((x) => !x.varietyTestLine);
                setRows(rows);
            }
            catch (error) {
                console.error("Error getting trial results", error);
            }
            //wait 2 seconds and set loading to false
            setTimeout(() => {
                setLoading(false);
            }, 500);
        });
        load();
    }, [trialResults]);
    const onResultTableRowsLoaded = () => {
        setLoading(false);
        console.log("ResultTableRows loaded");
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                position: "relative",
                overflow: "hidden",
                zIndex: 500,
                margin: "0px",
                minHeight: "80vh",
            } }, loading ? (React.createElement(Box, { sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            } })) : (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { onClick: scrollLeft, sx: {
                    position: "absolute",
                    left: -15,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1000,
                    backgroundColor: "green",
                    boxShadow: 3,
                } },
                React.createElement(ChevronLeftIcon, null)),
            React.createElement(TableContainer, { className: "table-container", ref: tableContainerRef, sx: {
                    paddingBottom: "3px",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    "&::-webkit-scrollbar": { display: "none" },
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                    zIndex: 1,
                } },
                React.createElement(Table, { sx: {
                        minWidth: `${distinctColumns.length > 0 ? distinctColumns.length * 160 : 800}px`, // Default to 800px if empty
                        position: "relative",
                    } },
                    React.createElement(TrialTableHeaderRow, { handleColumnClick: onColumnClick, sortConfig: headerRowSortConfig !== null && headerRowSortConfig !== void 0 ? headerRowSortConfig : {
                            selectedColumnIndex: 2,
                            direction: "asc",
                            selectedColumnID: "",
                        }, trialID: trialId, categoryId: categoryId, checkedDataTypeIds: checkedDataTypeIds, results: rows !== null && rows !== void 0 ? rows : [] }),
                    React.createElement(TableBody, null, rows && rows.length > 0 ? (React.createElement(ResultTableRows, { key: `${trialId}-${categoryId}`, sortConfig: resultRowSortConfig !== null && resultRowSortConfig !== void 0 ? resultRowSortConfig : {
                            selectedColumnIndex: 2,
                            direction: "desc",
                            selectedColumnID: "",
                        }, trialId: trialId, categoryId: categoryId, checkedDataTypeIds: checkedDataTypeIds, onLoaded: () => {
                            onResultTableRowsLoaded();
                        }, results: rows })) : (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: distinctColumns.length || 1, align: "center" }, "No data available")))))),
            React.createElement(IconButton, { onClick: scrollRight, sx: {
                    position: "absolute",
                    right: -15,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1000,
                    backgroundColor: "green",
                    boxShadow: 3,
                } },
                React.createElement(ChevronRightIcon, null)))))));
};
export default ResultTableContainer;
